export default __webpack_public_path__ + "static/media/delete.1422f5fc.svg";